import { useIntl } from '@leagueplatform/locales';
import { LinkLegacy as Link } from '@leagueplatform/routing';
import { AppBarLink } from '@leagueplatform/web-common-components';
import { sendNavBarAnalyticsEvent } from 'utils/analytics-events/nav-bar-analytics-events.util';
import { NavLink } from 'hooks/use-nav-links-list.hook';
import { styled, UtilityText } from '@leagueplatform/genesis-core';
import {
  isHashLink,
  AppHashLink,
} from 'components/header-nav/app-hash-link.component';

// Hash link styles specific to the desktop nav
const StyledHashLink = styled(AppHashLink, {
  textAlign: 'start',
  whiteSpace: 'nowrap',
  textDecoration: 'none',
  color: '$onSurfaceTextPrimary',
  '&:hover': {
    color: '$interactiveActionPrimary',
  },
  borderRadius: '$small',
  typography: '$buttonTwo',
});

export const AppNavLink = ({ navLink }: { navLink: NavLink }) => {
  const { formatMessage } = useIntl();
  const formattedMessage =
    navLink?.text || formatMessage({ id: navLink.message_id });

  if (isHashLink(navLink.to)) {
    return <StyledHashLink to={navLink.to}>{formattedMessage}</StyledHashLink>;
  }

  return (
    <AppBarLink
      as={Link}
      to={navLink.to}
      key={navLink.message_id}
      // if analytics is provided, analytics event will be sent by the parent component
      onClick={
        navLink?.analytics
          ? () => {}
          : sendNavBarAnalyticsEvent(navLink.message_id)
      }
      color="onSurface.text.primary"
      hoverStyle={{ color: 'interactive.action.primary' }}
      display="flex"
      justifyContent="center"
      alignItems="center"
      css={{
        textAlign: 'start',
        whiteSpace: 'nowrap',
        '&&': {
          paddingInline: '0',
        },
      }}
      listItemProps={{
        as: 'div',
      }}
    >
      <UtilityText
        css={{
          typography: '$buttonTwo',
          '&:hover': {
            color: '$interactiveActionPrimary',
          },
        }}
      >
        {formattedMessage}
      </UtilityText>
    </AppBarLink>
  );
};
